<template>
  <div>
    <div style="cursor: pointer;margin-bottom: 16px;color: #fff;" @click="back">
      <a-icon type="left" style="margin-right: 2px" />
      <span>返回</span>
    </div>

    <a-form
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 14 }"
      :colon="false"
      :form="form"
      @submit="handleSubmit"
    >
      <a-row>
        <a-col :lg="12" :md="12" :sm="24">
            <SelectField style="width: 90%; margin: 0.5rem auto" label="设备分类" id="type"
                         :modelValue="form.type" :options="deviceType" required labelWidth="40%"
                         @update:modelValue="(value) => handleModelValueUpdate('type', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="编号" type="text" id="code"
                        :modelValue="form.code" placeholder="请输入编号" required
                        @update:modelValue="(value) => handleModelValueUpdate('code', value)"
            />
        </a-col>
      </a-row>
      <a-row>
        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="名称" type="text" id="name"
                        :modelValue="form.name" placeholder="请输入名称" required
                        @update:modelValue="(value) => handleModelValueUpdate('name', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="唯一标识" type="text" id="sn"
                        :modelValue="form.sn" placeholder="请输入唯一标识" required
                        @update:modelValue="(value) => handleModelValueUpdate('sn', value)"
            />
        </a-col>
      </a-row>
      <a-row>
        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="经纬度" type="text" id="lnglat"  :disabled = "view === '修改设备'"
                        :modelValue="form.lnglat" placeholder="请输入经纬度" inputImg required @img-click="pasteLnglat"
                        @update:modelValue="(value) => handleModelValueUpdate('lnglat', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="依附井" type="text" id="well"  :disabled = "view === '修改设备'"
                        :modelValue="form.well" placeholder="请输入依附井" inputImg @img-click="pasteLnglat"
                        @update:modelValue="(value) => handleModelValueUpdate('well', value)"
            />

        </a-col>
      </a-row>
      <a-row>
        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="设备责任人" type="text" id="charger"
                        :modelValue="form.charger" placeholder="请输入设备责任人"
                        @update:modelValue="(value) => handleModelValueUpdate('charger', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="设备规格" type="text" id="specification"
                        :modelValue="form.specification" placeholder="请输入设备规格"
                        @update:modelValue="(value) => handleModelValueUpdate('specification', value)"
            />
        </a-col>
      </a-row>
      <a-row>
        <a-col :lg="24" :md="24" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="位置" type="text" id="location"
                        :modelValue="form.location" placeholder="请输入位置" labelWidth="13%" inputWidth="100%"
                        @update:modelValue="(value) => handleModelValueUpdate('location', value)"
            />
        </a-col>

        <a-col :lg="24" :md="24" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="设备备注" type="text" id="description"
                        :modelValue="form.description" placeholder="请输入设备备注" labelWidth="13%" inputWidth="100%"
                        @update:modelValue="(value) => handleModelValueUpdate('description', value)"
            />
        </a-col>
        <a-col :lg="24" :md="24" :sm="24">
            <SelectField style="width: 90%; margin: 0.5rem auto" label="设备状态" id="type"
                         :modelValue="form.status" :options="status" required labelWidth="13%"
                         @update:modelValue="(value) => handleModelValueUpdate('status', value)"
            />
        </a-col>
      </a-row>

      <div class="center">
        <a-space>
            <ButtonField text="取消" @click="back" secondary />
            <ButtonField text="保存" primary @click="handleSubmit"/>
        </a-space>
      </div>
    </a-form>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { fetchDetail, add, edit } from "@/api/assets/equip.js";
import store from "../mixins/store";
import SelectField from "@/components/water-affairs-style/field/SelectField.vue";
import InputField from "@/components/water-affairs-style/field/InputField.vue";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";
export default {
  mixins: [store],

  data() {
    return {
      detail: {},
      form: {
          type:null,
          code:null,
          name:null,
          sn:null,
          lnglat:null,
          well:null,
          charger:null,
          specification:null,
          location:null
      },
      well: {},
      saveLoading: false,
    };
  },
    components: {
        InputField,SelectField,ButtonField
    },
  watch: {
    selectedWell: {
      handler() {
        if (this.view === "修改设备" && this.selectedWell._edit) {
          this.getDetail();
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    deviceType() {
      return this.findDataDict("deviceType").filter(
        (item) => item.value !== "cutoffWell"
      );
    },
    status() {
      return this.findDataDict("status").map((item) => {
        return {
          value: parseInt(item.value),
          name: item.name,
        };
      });
    },
  },

  mounted() {
    if (this.view === "修改设备" && this.selectedWell._edit) {
      this.getDetail();
    }
  },

  methods: {
      handleModelValueUpdate(fieldName, value) {
          this.form[fieldName] = value;
      },
    getDetail() {
      this.detail = {};
      this.form = {

      };
      this.well = {};

      const hide = this.$message.loading("加载中...", 0);
      fetchDetail({ id: this.selectedWell.id })
        .then((res) => {
          console.log(res);
          if (!res) return;

          this.detail = res;

          this.form = {
              type:null,
              code:null,
              name:null,
              sn:null,
              lnglat:null,
              well:null,
              charger:null,
              specification:null,
              location:null
          }
          const obj = this.facilityList.find(
            (item) => item.id === res.devicePid
          );

          if (obj) {
            this.well = obj;
          }
            this.form.code = res.code;
            this.form.name = res.name;
            this.form.type = res.type;
            this.form.sn = res.sn;
            this.form.lnglat = res.x + "," + res.y;
            this.form.location = res.location;
            this.form.charger = res.charger;
            this.form.description = res.description;
            this.form.specification = res.specification;
            this.form.status = res.status;
            this.form.well = obj ? obj.name : "";
        })
        .finally(() => {
          hide();
        });
    },

    pasteLnglat() {
      const { lng, lat } = this.selectedLnglat;
      if (!lng) {
        this.$message.error("请点击地图选择经纬度");
        return;
      }
      this.form.setFieldsValue({
        lnglat: lng + "," + lat,
      });
    },

    pasteWell() {
      const { name, id, x, y } = this.selectedWell;
      if (!id) {
        this.$message.error("请选择依附井");
        return;
      }
      this.well = { ...this.selectedWell };
      this.form.setFieldsValue({
        well: name,
        lnglat: x + "," + y,
      });
    },

    handleSubmit() {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        if (!this.form.type) {
            this.$message.error('设备分类不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.code) {
            this.$message.error('编号不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.name) {
            this.$message.error('名称不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.lnglat) {
            this.$message.error('经纬度不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.sn) {
            this.$message.error('唯一标识不能为空');
            this.isSubmitting = false;
            return;
        }

          const arr = this.form.lnglat.split(",");
          const x = parseFloat(arr[0]);
          const y = parseFloat(arr[1]);

          const params = {
            id: this.detail.id,
            ...this.form,
            lnglat: undefined,
            devicePid: this.well ? this.well.id : undefined,
            x,
            y,
          };

          let task = add;

          if (this.detail.id) {
            task = edit;
          }

          task(params)
            .then(() => {
              this.getFacilityList();
              this.back();
            })
            .finally(() => {
                this.isSubmitting = false;
            });
    },

    back() {
      this.detail = {};
      this.form = {
          type:null,
          code:null,
          name:null,
          sn:null,
          lnglat:null,
          well:null,
          charger:null,
          specification:null,
          location:null
      }
      this.well = {};

      this.setSelectedLnglat({});
      this.setSelectedWell({});

      this.setView("设备");
    },
  },
};
</script>
<style lang="less" scoped>
.location {
  display: block;
  height: auto;
  width: 12px;
}

.center {
  padding-bottom: 24px;
}
</style>
